export default "__VITE_ASSET__U3B_tV4D__"